import React from 'react';
import { useAppSelector } from "common/hook";
import InfoTeacher from "./info-teacher/Info-teacher";
import { InfoStudents } from "./info-student/info-students";
import { ROLE_DEMO_STUDENT, ROLE_HR, ROLE_STUDENT, ROLE_TEACHER } from "entities/constants/constants";



 const profileInfoComponents = {
    [ROLE_TEACHER]: <InfoTeacher />,
    [ROLE_HR]: <InfoTeacher />,
    [ROLE_STUDENT]: <InfoStudents />,
    [ROLE_DEMO_STUDENT]: <InfoStudents />,
};

export const ProfileInfo = () => {
    const roleType = useAppSelector((state) => state.role.roleType);

    const profileComponent = roleType ? profileInfoComponents[roleType] : null;

    return (
        <>
            {profileComponent}
        </>
    );
};


